import { FC } from 'react';
import { useAppSelector } from 'src/app/redux/createAction';
import { Preloader } from 'src/shared/ui/_loaders/Preloader';
import s from './FinalizingMessage.module.scss';

export const FinalizingMessage: FC = () => {
	const finalizing = useAppSelector((state) => state.company.finalizing);

	if (finalizing === null) return null;

	const getFinalizingMessage = () => {
		if (finalizing === 'finalizing') {
			return 'Processing your data';
		}

		if (finalizing === 'submitting') {
			return 'Generating company report';
		}
	};

	return (
		<div className={s.container}>
			<Preloader size="small" />
			{getFinalizingMessage()}
		</div>
	);
};
